import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

type DeleteArchitectureEntityDialogProps = {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  isDeleting: boolean
  titleKey: string
  descriptionKey: string
}

export function DeleteArchitectureEntityDialog({
  isOpen,
  onClose,
  onConfirm,
  isDeleting,
  titleKey,
  descriptionKey,
}: DeleteArchitectureEntityDialogProps) {
  const { t } = useTranslation('machineryDirectiveCompliance')

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent showCloseButton={!isDeleting}>
        <DialogHeader>
          <DialogTitle>{t(titleKey)}</DialogTitle>
        </DialogHeader>
        <p className='text-sm text-muted-foreground'>{t(descriptionKey)}</p>
        <DialogFooter>
          <Button variant='outline' onClick={onClose} disabled={isDeleting}>
            {t('common:actions.cancel')}
          </Button>
          <Button
            variant='destructive'
            onClick={onConfirm}
            disabled={isDeleting}
          >
            {t('safetyFunctionsPage.architecture.deleteConfirm')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
